import { z } from 'zod';

export const marketingDatesCommoditiesSchema = z.object({
  marketingDates: z.array(z.string()),
  commoditiesMap: z.record(
    z.object({
      commodities: z.array(z.string()),
      commodityTypes: z.record(z.array(z.string())),
    })
  ),
});

export type MarketingDatesCommodities = z.infer<
  typeof marketingDatesCommoditiesSchema
>;
